import { computed, watch, ref } from '@vue/composition-api'

import useRequest from '@/compositions/useRequest'
import useForm from '@/compositions/useForm'

import { required, requiredIf } from '@/utils/validations'
import { medium, backendFormat } from '@/utils/formatDate'

import { occupationType } from '@/constants/occupations'

import DatePicker from '@/components/DatePicker/DatePicker'
import TimePicker from '@/components/TimePicker/TimePicker'
import Intersection from '@/components/Intersection/Intersection'
import DefaultModalWrapper from '@/components/DefaultModalWrapper/DefaultModalWrapper.vue'

export default {
  name: 'OccupationDialog',
  props: ['value', 'data', 'instances'],
  components: {
    DatePicker,
    TimePicker,
    Intersection,
    DefaultModalWrapper,
  },
  setup(props, context) {
    const { $store } = context.root
    const { emit } = context
    const { $notifier } = context.root
    const isOpenIntersectionModal = ref(false)
    const showDateFields = computed(() => !props.data)

    const occupationTime = computed(
      () => {
        if (!props.value || showDateFields) return ''
        return `С ${medium(props.data.start, 'PP')} по ${medium(props.data.end, 'PP')}`
      },
    )

    const {
      validate, $errors, formData, getData, reset,
    } = useForm({
      fields: {
        occupationType: { default: '', validations: { required } },
        occupationCommentary: { default: '', validations: { required } },
        dateStart: { default: '', validations: { required: requiredIf(() => showDateFields.value) } },
        dateEnd: { default: '', validations: { required: requiredIf(() => showDateFields.value) } },
        instanceId: { default: '', validations: { required: requiredIf(() => showDateFields.value) } },
      },
    })

    const minEndDate = computed(() => getData().dateStart)
    const maxEndDate = computed(() => {
      if (!getData().dateStart) return null
      const newDate = new Date(getData().dateStart)
      newDate.setDate(newDate.getDate() + 2)
      return newDate.toISOString()
    })

    const { loading, makeRequest } = useRequest({
      context,
      successMessage: 'Отправлено!',
      request: resetRequest => $store.dispatch('calendar/postOccupationState', {
        id: showDateFields.value ? getData().instanceId : props.data.id,
        data: {
          date_start: showDateFields.value ? getData().dateStart : backendFormat(props.data.start, 'yyyy-M-dd'),
          date_end: showDateFields.value ? getData().dateEnd : backendFormat(props.data.end, 'yyyy-M-dd'),
          comment: getData().occupationCommentary,
          occupation_type: getData().occupationType,
          ...(resetRequest ? { resetRequest } : { resetRequest: false }),
        },
      }),
    })

    const occupationDialog = computed({
      get: () => Boolean(props.value),
      set: (val) => {
        if (!val) emit('input', Boolean(null))
      },
    })

    const submit = async () => {
      if (!validate()) return
      const item = await makeRequest(null, false)
      emit('submitted', { id: showDateFields.value ? getData().instanceId : props.data.id, item })
      isOpenIntersectionModal.value = item.needPopUp
      occupationDialog.value = item.needPopUp
      if (item.needPopUp === false) {
        $notifier.showMessage({ content: 'Отправлено', color: 'success' })
        reset()
      }
    }
    const handleSubmitIntersectionModal = async () => {
      const item = await makeRequest(true)
      emit('submitted', { id: showDateFields.value ? getData().instanceId : props.data.id, item })
      occupationDialog.value = false
      isOpenIntersectionModal.value = false
      reset()
    }
    const handleCloseIntersectionModal = () => {
      isOpenIntersectionModal.value = false
    }
    watch(() => formData.dateStart.value, (val) => {
      if (!val) return
      formData.dateEnd.value = ''
    })


    return {
      showDateFields,
      occupationTime,
      occupationDialog,
      formData,
      loading,
      $errors,
      minEndDate,
      maxEndDate,
      submit,
      handleSubmitIntersectionModal,
      handleCloseIntersectionModal,
      isOpenIntersectionModal,
      types: Object.keys(occupationType).map(key => ({
        text: occupationType[key].label,
        value: occupationType[key].value,
      })),
    }
  },
}
